import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import App from './App.vue'

// Importa Bootstrap CSS y JS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import './assets/css/main.css'

// Componentes
import Home from './Home.vue'
import Nosotros from './Nosotros.vue'
import Creditos from './Creditos.vue'
import CreditoSimpleOS from './CreditoSimpleOS.vue'
import CreditoSimplePF from './CreditoSimplePF.vue'
import CreditoSimpleGF from './CreditoSimpleGF.vue'
import CalculadoraCredito from './CalculadoraCredito.vue'

const routes = [
    {
        path: '/',
        component: Home
    },
    {
        path: '/Nosotros',
        component: Nosotros
    },
    {
        path: '/Creditos',
        component: Creditos
    },
    {
        path: '/Creditos/Persona-Fisica',
        component: CreditoSimplePF
    },
    {
        path: '/Creditos/Obligado-Solidario',
        component: CreditoSimpleOS
    },
    {
        path: '/Creditos/Garantia-Fiduciaria',
        component: CreditoSimpleGF
    },
    {
        path: '/Creditos/Calculadora-Credito',
        component: CalculadoraCredito
    }
]

const router =  createRouter({
    history: createWebHashHistory(),
    routes,
})

const app = createApp(App)

app.use(router)

app.mount('#app')
